import React from "react";
import { Row, Container, Col } from "react-bootstrap";
import ServiceBanner from "../Components/ServiceBanner";
import Footer from "../Components/Footer";
import ServiceBar from "../Components/ServiceBar";
import customBanner from "../Images/auto.jpg";

export default function About() {
  return (
    <>
      <div className="fadeIn animated">
        <ServiceBanner
          customImage={customBanner}
        />

        <Row className="no-gutters mt-4 ">
          <Container>
            <Row>
              <Col sm={12} className="text-center ">
              <h3>Revolutionize your industrial operations with our smart IoT gateways, built for ultimate control, connectivity, and scalability</h3>
                <blockquote className="mt-4 font-italic">
                  <sup>
                    <i className="fa fa-quote-left" aria-hidden="true"></i>
                  </sup>{" "}
                  Our gateways offer unparalleled flexibility, combining robust communication capabilities with intelligent data management. These gateways integrate effortlessly into existing systems, providing real-time data acquisition and control while supporting multiple protocols, including Modbus and MQTT. Whether you’re managing energy systems or monitoring critical infrastructure, our gateways deliver reliable performance and scalability, even in the most demanding industrial environments{" "}
                  <sup>
                    <i className="fa fa-quote-right" aria-hidden="true"></i>
                  </sup>
                </blockquote>
              </Col>
            </Row>
          </Container>
        </Row>

       <section className="py-5 bg-light">
  <Container>
    <Row className="text-center">
      {/* Feature 1 */}
      <Col md={3} sm={6} xs={12} className="mb-4 animate__animated animate__fadeInUp">
        <i className="bi bi-arrow-left-right fa-3x mb-3 text-primary"></i>
        <hr className="my-3" />
        <h5>Multi-Protocol Support</h5>
        <div className="btSubTitle small">
          Seamlessly integrates Modbus RTU/TCP, FTP, MQTT, and M-Bus for maximum flexibility in communication
        </div>
        <hr className="my-3" />
      </Col>

      {/* Feature 2 */}
      <Col md={3} sm={6} xs={12} className="mb-4 animate__animated animate__fadeInUp animate__delay-1s">
        <i className="bi bi-backpack2 fa-3x mb-3 text-success"></i>
        <hr className="my-3" />
        <h5>Seamless Cloud Integration</h5>
        <div className="btSubTitle small">
          Effortlessly connect to cloud platforms via MQTT or FTP for real-time data transmission, remote monitoring, and centralized control from anywhere.
        </div>
        <hr className="mt-4" />
      </Col>

      {/* Feature 3 */}
      <Col md={3} sm={6} xs={12} className="mb-4 animate__animated animate__fadeInUp animate__delay-2s">
        <i className="bi bi-bookmark-plus fa-3x mb-3 text-warning"></i>
        <hr className="my-3" />
        <h5>Real-Time Alerts</h5>
        <div className="btSubTitle small">
          Stay informed with fully configurable alarm systems that send instant alerts via SMS, email, or MQTT, helping you respond to critical events immediately.
        </div>
        <hr className="mt-4" />
      </Col>
      <Col md={3} sm={6} xs={12} className="mb-4 animate__animated animate__fadeInUp animate__delay-2s">
        <i className="bi bi-bookmark-plus fa-3x mb-3 text-warning"></i>
        <hr className="my-3" />
        <h5>Industrial-Grade Reliability</h5>
        <div className="btSubTitle small">
          Using specialized tools to automatically test software applications, ensuring quality and reducing time in QA cycles.
        </div>
        <hr className="mt-4" />
      </Col>
    </Row>
  </Container>
</section>


        <ServiceBar />
        <Footer />
      </div>
    </>
  );
}
